var _path, _g, _path2, _g2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 32,
    viewBox: "0 0 61 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1526_1908",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 0,
    width: 38,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0097 0.134917H24.4561V31.7541H61.0097V0.134277V0.134917Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1526_1908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0097 15.9442C61.0097 7.25748 53.9671 0.186117 45.2913 0.136197C45.2759 0.136197 45.2605 0.134277 45.2445 0.134277H40.1162C39.9057 0.134277 39.6972 0.175745 39.5027 0.256314C39.3082 0.336882 39.1315 0.454973 38.9826 0.603844C38.8337 0.752715 38.7156 0.92945 38.6351 1.12396C38.5545 1.31847 38.513 1.52694 38.513 1.73748C38.513 1.94801 38.5545 2.15649 38.6351 2.351C38.7156 2.5455 38.8337 2.72224 38.9826 2.87111C39.1315 3.01998 39.3082 3.13807 39.5027 3.21864C39.6972 3.29921 39.9057 3.34068 40.1162 3.34068H45.201C52.1501 3.34068 57.8052 8.99444 57.8052 15.9442C57.8052 22.8946 52.1501 28.5484 45.201 28.5484H27.6612V25.6184H24.4561V31.7541H45.2445C53.9421 31.7285 61.0097 24.6463 61.0097 15.9442Z",
    fill: "#009FE4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1526_1908",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8413 0.134917H0.287109V31.7541H36.8413V0.134277V0.134917Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1526_1908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.287109 15.9442C0.287109 24.6309 7.32967 31.7023 16.0055 31.7522C16.0209 31.7522 16.0362 31.7541 16.0522 31.7541H21.1812C21.6063 31.7541 22.014 31.5852 22.3146 31.2846C22.6152 30.984 22.7841 30.5763 22.7841 30.1512C22.7841 29.7261 22.6152 29.3184 22.3146 29.0178C22.014 28.7172 21.6063 28.5484 21.1812 28.5484H16.097C9.14727 28.5484 3.49287 22.8946 3.49287 15.9442C3.49287 8.99444 9.14727 3.34004 16.097 3.34004H33.6356V6.26996H36.8413V0.134277H16.0516V0.134917C7.35399 0.160517 0.287109 7.24212 0.287109 15.9442Z",
    fill: "#009FE4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6511 17.3541L13.6572 9.41747H10.0322L15.2418 22.4517H17.7513L23.1279 9.41747H19.6956L16.6511 17.3541ZM33.638 17.7112L28.5641 9.41747H24.4597V22.4524H27.6578V13.9436L32.8738 22.4524H36.8354V9.41747H33.638V17.7112ZM46.0047 14.5496V17.534H48.2684V19.2472C47.9761 19.3857 47.6736 19.5012 47.3634 19.5928C46.9461 19.7228 46.4399 19.7887 45.8569 19.7887C45.2937 19.7887 44.7778 19.6927 44.3247 19.502C43.8842 19.3203 43.4865 19.0484 43.1573 18.7039C42.828 18.3548 42.5733 17.9424 42.4085 17.4917C42.2345 17.0252 42.1461 16.5004 42.1461 15.9346C42.1461 15.3797 42.2345 14.8588 42.4085 14.3858C42.5718 13.9317 42.8267 13.5161 43.1573 13.1647C43.487 12.8209 43.8846 12.5493 44.3247 12.3672C44.7785 12.1765 45.2937 12.0799 45.8569 12.0799C46.5378 12.0799 47.1106 12.1765 47.5573 12.3672C48.0053 12.5573 48.4137 12.8408 48.7721 13.2108L48.9269 13.3695L51.1765 10.9151L51.0249 10.7736C50.3647 10.162 49.5693 9.71511 48.7036 9.46931C47.8396 9.22227 46.8815 9.09619 45.8569 9.09619C44.8508 9.09619 43.9087 9.25619 43.0581 9.57299C42.2301 9.87417 41.4721 10.3408 40.8303 10.9445C40.2063 11.5384 39.7129 12.2668 39.3647 13.1103C39.0172 13.9519 38.8405 14.9023 38.8405 15.9346C38.8405 16.9669 39.0172 17.9173 39.3653 18.7589C39.7141 19.6031 40.2063 20.3314 40.8303 20.9247C41.4537 21.5173 42.2037 21.9788 43.0575 22.2962C43.9087 22.6124 44.8508 22.7724 45.8569 22.7724C46.7938 22.7724 47.7257 22.6751 48.6281 22.4831C49.5395 22.288 50.4201 21.9697 51.2457 21.5372L51.3589 21.4796V14.549L46.0047 14.5496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.a6ccbc3ed7c1f04d0f2d42473f9abb6b.svg";
export { ForwardRef as ReactComponent };